<template>
  <img
    class="logo"
    :style="`width: ${width}px; height: ${height}px`"
    src="../assets/logo.svg"
    alt="Vale Saúde Sempre"
  />
</template>

<script>
export default {
  name: 'Logo',
  props: ['width', 'height']
};
</script>

<style lang="scss">
.logo {
  display: block;
  margin: 0 auto;
}
</style>
